module.exports = __webpack_public_path__ + "static/img/cover-image-2.7722092.png";